import { render, staticRenderFns } from "./QuickCreator.vue?vue&type=template&id=4f697452"
import script from "./QuickCreator.vue?vue&type=script&lang=js"
export * from "./QuickCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports